import { AmountControlInterface } from '../components/amount-input/interfaces';

import { BaseControl } from './base-control';

export class AmountControl extends BaseControl<any> {
  public currency: string;

  constructor(data: AmountControlInterface) {
    super(data);

    this.currency = '';
  }
}
